import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CalendarService } from '../../../../../app/services/calendar.service';
import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackCalendar } from '../../../../../app/models/dataPackCalendar.model';

  import * as _ from "lodash";
import { DataPackLine } from '../../../../models/start';

/**
 * @version $Id: content.component.ts 82300 2018-03-15 18:11:43Z bernardo.d.siqueira $
 */
@Component({
  selector: 'setCalendarModal',
  templateUrl: './content.template.html'
})
export class SetCalendarModalComponent implements OnInit {

  @Input() calendars: Array<DataPackCalendar> = new Array<DataPackCalendar>();
  @Input() group: DataPackGroup;
  @Input() lines: Array<DataPackLine>;

  private form: FormGroup;
  private applying: boolean;

  constructor(private activeModal: NgbActiveModal, private formBuilder: FormBuilder, private calendarService: CalendarService, private alertService: AlertService) {

  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      calendar: this.calendars[0]
    });
  }

  private close() {
    this.activeModal.dismiss();
  }

  private apply() {
    this.applying = true;
    let payload: any = {
      calendar: {id: this.form.value.calendar.id, description: this.form.value.calendar.description},
      group: {id: this.group.id},
      lines: _.map(this.lines, (line) => {
        return _.pick(line, ['lineNumber', 'account', 'userName'])
      })
    };
    this.calendarService.setCalendar(payload).subscribe(
      data => {
        this.applying = false;
        this.alertService.success(data['result']);
        this.activeModal.close();
      },
      err => {
        this.applying = false;
        this.alertService.error(err.result, err);
        this.activeModal.dismiss();
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/calendar/set/content.component.ts